
import '@fancyapps/fancybox';

const fancyBox = () => {
    $('[data-fancybox="gallery"]').fancybox({
    });
};

export default fancyBox;




// WEBPACK FOOTER //
// ./src/scripts/components/global/fancybox.js